import React, { useEffect, useState } from "react";
import { styled, useStyletron } from "baseui";
import { Button } from "baseui/button";
import { Input, SIZE } from "baseui/input";
import { ParagraphSmall } from "baseui/typography";
import { FaTimes } from "react-icons/fa";
import { connect } from "react-redux";
import { fetchUser } from "../../redux/user/UserThunk";

const Container = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  height: "100%",
  maxWidth: "800px",
  margin: "0 auto",
});

const FormContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

const FieldContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "1px",
});

const UpperSection = styled("div", {
  maxWidth: "400px",
  width: "100%",
  margin: "0 auto",
});

const SaveButton = styled(Button, {
  marginTop: "24px",
  width: "100px",
});

const UserAccountProfileView = (props) => {
  const [css] = useStyletron();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    props.getUser(props.userID);
  }, [props.userID]);

  return (
    <Container>
      <UpperSection>
        <FormContainer>
          <FieldContainer>
            <label htmlFor="username">Username:</label>
            <ParagraphSmall>
              The unique identifier assigned to you when you create an account.
              It's how the system recognizes you and distinguishes you from
              other users. This username is set at the time of account creation
              and cannot be changed once set
            </ParagraphSmall>
            <Input
              disabled
              size={SIZE.mini}
              id="username"
              value={props.username}
              //   onChange={(e) => setUsername(e.target.value)}
            />
          </FieldContainer>

          <FieldContainer>
            <label htmlFor="email">Email Address</label>
            <ParagraphSmall>
              The primary electronic address associated with your account. It's
              used for communication, notifications, and password recovery.
              Similar to your username, your email address is also set at the
              time of account creation and cannot be altered.
            </ParagraphSmall>
            <Input
              disabled
              size={SIZE.mini}
              id="email"
              value={props.email}
              //   onChange={(e) => setEmail(e.target.value)}
            />
          </FieldContainer>

          {/* <SaveButton
            size={SIZE.mini}
            shape="pill"
            onClick={() => console.log("Save user info")}
          >
            Save
          </SaveButton> */}
        </FormContainer>
      </UpperSection>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    username: state.user.username,
    email: state.user.email,
    userID: state.user.userId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUser: (id) => dispatch(fetchUser(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAccountProfileView);
